import PropertyClassificationList from "containers/property/PropertyClassificationList";
import { Modal } from "react-bootstrap";

function PropertyClassificationModal({ 
        isAuthenticated, 
        user,
        show,
        filter,
        data,
        updateTableState,
        saveRecord,
        deleteRecord,
        validateRelatedRecord,
        classificationOptions,
        onClose, 
    }) {

  // --- Render Functions ---
    function renderComponent() {
        return (
            <Modal show={show} onHide={onClose} dialogClassName="property-table-modal-wide">
                <Modal.Header closeButton>
                    <Modal.Title>Property Classifications</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <PropertyClassificationList
                        filter={filter}
                        user={user}
                        isAuthenticated={isAuthenticated}
                        isLoading={false}
                        controlType="table"
                        classificationOptions={classificationOptions}
                        data={data}
                        updateTableState={updateTableState}
                        saveRecord={saveRecord}
                        deleteRecord={deleteRecord}
                        />
                    </Modal.Body>
            </Modal>
        );
    }
    return (
        <div className="PropertyClassificationEdit">
            {isAuthenticated ? renderComponent() : null}
        </div>
    );
}

export default PropertyClassificationModal;